/**
 * Portal Manta · StackedBar
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function StackedBar({segments, height=22}){
  // segments: [{label, value, color}]
  const total = segments.reduce((s,x)=>s+x.value,0)||1;
  return (<div>
    <div style={{display:'flex',height,borderRadius:6,overflow:'hidden',border:'1px solid '+V.g2}}>
      {segments.map((s,i)=>(<div key={i} title={`${s.label}: ${s.value}%`} style={{width:`${s.value/total*100}%`,background:s.color,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:10,fontWeight:700}}>
        {s.value>=8 ? `${s.value}%` : ''}
      </div>))}
    </div>
    <div style={{display:'flex',gap:14,marginTop:6,flexWrap:'wrap'}}>
      {segments.map((s,i)=>(<div key={i} style={{display:'flex',alignItems:'center',gap:5,fontSize:10.5,color:V.g5}}>
        <div style={{width:9,height:9,borderRadius:2,background:s.color}}/>{s.label} <span style={{color:V.g4}}>{s.value}%</span>
      </div>))}
    </div>
  </div>);
}

export { StackedBar };
export default StackedBar;
